import io from 'socket.io-client'
import { createContext, useEffect } from 'react'

export const SocketContext = createContext({})
const socket = io(`${process.env.REACT_APP_BACKEND_URL}`)
export const SocketProvider = ({ children }) => {
//   const [socket, setSocket] = useState()
// const socket = useRef(null)

  useEffect(() => {
    if (!socket) {
        // setSocket(
        //     io(`${process.env.REACT_APP_BACKEND_URL}`)
        // )
        console.log('connecting socket')
        // socket = io(`${process.env.REACT_APP_BACKEND_URL}`)
        
    }
    return () => {
        if (socket) {
            console.log('disconnecting socket')
            // socket.disconnect()
        }
    }
  }, [])

  const value = {
    socket: socket
  }
//   console.log('socket value', JSON.stringify(value))
  useEffect(() => {
    if (socket) {
      // Initialize socket
      socket.on('connect', () => {
        console.log(`socket connected ${socket.id}`)
      })
      socket.on('disconnect', reason => {
        console.log(`socket disconnected ${reason}`)
      })
      // Stop listening on socket on close
      return () => {
        socket.off('connect')
        socket.off('disconnect')
      }
    }
  }, [])

  return (
    <SocketContext.Provider value={value}>{children}</SocketContext.Provider>
  )
}
